function hideElement(el) {
    if (el) {
        el.style.display = 'none';
    }
}
function hideGlobal(state) {
    switch (state) {
        case 'notices':
        case 'defendher':
            break;
        default:
            hideElement(document.querySelector('.cc-grower'));
            hideElement(document.querySelector('.indications-top'));
            if (state !== 'isi-tray') {
                hideElement(document.querySelector('.isi-tray'));
            }
            break;
    }
}
Evoke.Screenshots.Setup.registerTask(async (task) => {
    document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.removeAttribute('loading');
    });
    await Evoke.sleep(1000);
    if (location.pathname === '/') {
        hideGlobal(task.state);

        switch (task.state) {
            case 'external-interstitial':
                document.querySelector('a[data-a11y-dialog-show="external"]').click();
                await Evoke.sleep(1000);
                break;
            case 'mobile-nav':
                document.querySelector('.primary-nav__toggle').click();
                break;
            case 'sitemap':
                document.querySelector('a[data-a11y-dialog-show="external3"]').click();
                await Evoke.sleep(1000);
                document.querySelector('#external3 button.dialog-close').blur();
                break;
            case 'isi-tray':
                document.querySelector('.isi-tray__toggle button').click();
                await Evoke.sleep(500);
                break;
        }
    } else {
        hideGlobal();

        switch (task.state) {
            case 'expand':
                // if (location.pathname.startsWith('/ee/')) {
                //     $(".js-speaker-toggle").each(function () { $(this).click(); });
                // } else {
                    document.querySelectorAll('[data-toggle="collapse__body"]').forEach((btn) => {
                        btn.classList.toggle('active');
                        document.querySelectorAll(btn.getAttribute('data-target')).forEach((t) => {
                            t.classList.toggle('show');
                        });
                    });
                // }
                break;
            // case 'rxlightning-interstitial':
            //     document.querySelector('a[data-a11y-dialog-show="external4"]').click();
            //     await Evoke.sleep(1000);
            //     document.querySelector('#external4 button.dialog-close').blur();
            //     break;
        }
    }
    task.complete(1000);
});